import { render, staticRenderFns } from "./ResellerWebhook.vue?vue&type=template&id=60e29284"
import script from "./ResellerWebhook.vue?vue&type=script&lang=js"
export * from "./ResellerWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports